import { Tooltip } from '@assembly-js/design-system';
import { makeStyles } from '@material-ui/core';
import React, { CSSProperties } from 'react';

import { green, yellow } from 'src/theme/colors';
import { zIndex } from 'src/theme/zindex';

interface BaseStatusIndicatorProps {
  title: React.ElementType | React.ReactFragment | string;
  customSpacings?: CSSProperties;
  isSuccess?: boolean;
  hasTooltip?: boolean;
}

const useStyles = makeStyles(() => ({
  centeredContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  baseStatusIndicator: {
    position: 'absolute',
    height: 8,
    width: 8,
    borderRadius: '50%',
    zIndex: zIndex.tooltip,
  },
  baseStatusIndicatorSuccess: {
    backgroundColor: green,
  },
  baseStatusIndicatorDefault: {
    backgroundColor: yellow,
  },
}));

export const BaseStatusIndicator = (props: BaseStatusIndicatorProps) => {
  const classes = useStyles();
  const { hasTooltip = true, title, isSuccess = false, customSpacings } = props;

  const getBaseStatusIndicatorClass = () => {
    if (isSuccess) {
      return classes.baseStatusIndicatorSuccess;
    }

    return classes.baseStatusIndicatorDefault;
  };
  return (
    <Tooltip disabled={!hasTooltip} content={title}>
      <div className={classes.centeredContainer}>
        <div
          className={`${
            classes.baseStatusIndicator
          } ${getBaseStatusIndicatorClass()}`}
          style={{ ...customSpacings }}
        />
      </div>
    </Tooltip>
  );
};
